import { ShiftPendingReviews } from '~/components/ShiftPendingReviews';

export const PendingReviewShiftsTab = () => {
  return <ShiftPendingReviews isCompact />;
};
